export default __webpack_public_path__ + "static/media/cinamon.fb68bd13.png";